import { createContext } from 'react'
import { ConfigsType } from './../config'
import * as allConfigs from './../config'

const { appConfig, ...configs } = allConfigs
export const ConfigsContext = createContext<ConfigsType>(configs)